import { Section } from "../../components/Section";
import { Scriptbox } from "../../components/Scriptbox";
export function Authentication({ takeref }: { takeref: any }) {
  const codeString = `function add(a, b) {
    return a + b; 
  }`;
  const codestring2 = `from pathlib import Path
  import openai
  
  speech_file_path = Path(__file__).parent / ""
  response = openai.audio.speech.create(
    model="tts-1",
    voice="alloy",
    input="The quick brown fox jumped over the lazy dog."
  )
    `;
  return (
      <Section heading="Organization" takeref={takeref}>
        <h3>Script for GET API of Organization</h3>
        <p>
          <b>Introduction:</b> This is the GET API for fetching information about
          your organization. Using this API, you can retrieve comprehensive
          details about your organization, including its name, contact
          information, address, and status.
        </p>
        <h4>Sample Request:</h4>
        <p>
          Send a GET request to the endpoint:
          <code>https://internals.pointx.one/externals/v1/get-organisation-details/</code>
        </p>
        <h4>Response:</h4>
        <p>
          If the request is successful, the API returns a JSON response containing
          the organization’s details. Below is an example of the response
          structure with dummy data:
        </p>
        <pre>
          
          <Scriptbox codelanguage={["javascript"]} codedata={[`{
      "error": false,
      "msg": "Organization",
      "user": {
          "id": 101,
          "name": "Jon Doe",
          "email": "jondoe1234@example.com",
          "phone": "+1234567890",
          "address": "123 Dummy Street, Example Town",
          "city": "Sample City",
          "state": "Sample State",
          "country": "Nowhere",
          "zipcode": "000000",
          "website": "example.org",
          "is_active": true
      }
  }`]}/>
            
        </pre>
        <h4>Response Details:</h4>
        <ul>
          <li>
            <b>error:</b> Indicates whether there was an error in the request. In
            this case, it's <code>false</code>, meaning the request was
            successful.
          </li>
          <li>
            <b>msg:</b> A short message summarizing the response, here it says
            <code>"Organization"</code>.
          </li>
          <li>
            <b>user:</b> Contains all the key details of the organization.
          </li>
        </ul>
        <h4>Dummy Organization Details:</h4>
        <ul>
          <li>
            <b>id:</b> Unique identifier for the organization (e.g., <code>101</code>).
          </li>
          <li>
            <b>name:</b> Name of the organization or owner (e.g., <code>"Jon Doe"</code>).
          </li>
          <li>
            <b>email:</b> Official email address (e.g., <code>"jondoe1234@example.com"</code>).
          </li>
          <li>
            <b>phone:</b> Contact number (e.g., <code>"+1234567890"</code>).
          </li>
          <li>
            <b>address:</b> Full address (e.g., <code>"123 Dummy Street, Example Town"</code>).
          </li>
          <li>
            <b>city:</b> City of the organization (e.g., <code>"Sample City"</code>).
          </li>
          <li>
            <b>state:</b> State where the organization is located (e.g., <code>"Sample State"</code>).
          </li>
          <li>
            <b>country:</b> Country of the organization (e.g., <code>"Nowhere"</code>).
          </li>
          <li>
            <b>zipcode:</b> Postal code (e.g., <code>"000000"</code>).
          </li>
          <li>
            <b>website:</b> Website URL of the organization (e.g., <code>"example.org"</code>).
          </li>
          <li>
            <b>is_active:</b> Indicates if the organization is active (e.g., <code>true</code>).
          </li>
        </ul>
        {/* <Scriptbox
          codedata={[codeString, codestring2]}
          codelanguage={["javascript", "python"]}
        /> */}
      </Section>
    );
  }